module.exports = __webpack_public_path__ + "media/images/lilica-home-3679022cf016c6b8e6576fbafc7ee575.jpg";